<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">Special thanks to Graham Edwards</p>
<p class="ded1">For M. K.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?38587fef